<template>
  <div class="animated fadeIn" style="height:100%; width:auto;">
    <b-card>
      <div slot="header">
        {{this.$route.meta.title}}
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="close()">
            <i class="fa fa-close"></i> {{$t('close')}}
          </button>
        </div>
      </div>
      <b-row>
        <b-col lg="10">
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>No. Agreement</label>
                </b-input-group-prepend>
                <b-form-input
                  readonly
                  v-model="model.no_agreement"
                  @keyup.13.native="lkuPinjamanShow=true"
                  :state="!$v.model.pinjamankey.$error"
                ></b-form-input>
                <b-input-group-append v-if="!isdetail">
                  <b-btn text="Button" @click="lkuPinjamanShow=true">
                    <i class="fa fa-search"></i>
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width:100px">No. Kontrak</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.no_kontrak" readonly></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Debitur Name</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.CustName" disabled></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
               <b-input-group>
                <b-input-group-prepend>
                  <label>Debitur No. (CIF)</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.CustCode" disabled></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
           <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Tenor</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.tenor" readonly class="text-right"></b-form-input>
                <b-input-group-prepend><span class="input-group-text" style="width:70px;">Bulan</span></b-input-group-prepend>
              </b-input-group>
            </b-col>
            <b-col lg="6">
               <b-input-group>
                <b-input-group-prepend>
                  <label>Go Live - Maturity Date</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.startdate_frmt" readonly></b-form-input>
                <b-input-group-prepend><span class="input-group-text">-</span></b-input-group-prepend>
                    <b-form-input v-model="model.duedate_frmt" readonly></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
           <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Effective Rate (%)</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.bunga_tarifthn" readonly class="text-right"></b-form-input>
                <b-input-group-prepend><span class="input-group-text" style="width:70px;">%</span></b-input-group-prepend>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Virtual Account No</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.vanumber" readonly></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Penggunaan</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.purpose_of_fin_name" disabled></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Cessie Group</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.pjxname" readonly></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Branch</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.branch" disabled></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>LDSK</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.LDSK" readonly></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col lg="10">
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>DOD</label>
                </b-input-group-prepend>
                 <my-number
                  class="form-control text-right"
                  v-model="model.days_over_due"
                  :precision="0"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
            <b-col lg="6">
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>OS LC Installament</label>
                </b-input-group-prepend>
                <my-number
                  class="form-control text-right"
                  v-model="model.latecharge_outstand"
                  :precision="2"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
            <b-col lg="6">
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>OS Principal</label>
                </b-input-group-prepend>
                <my-number
                  class="form-control text-right"
                  v-model="model.principal_outstand"
                  :precision="2"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>OS Interest</label>
                </b-input-group-prepend>
                <my-number
                  class="form-control text-right"
                  v-model="model.interest_outstand"
                  :precision="2"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
          </b-row>
           <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>OS Principal Undue</label>
                </b-input-group-prepend>
                <my-number
                  class="form-control text-right"
                  v-model="model.principal_outstand_undue"
                  :precision="2"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>OS Interest Undue</label>
                </b-input-group-prepend>
                <my-number
                  class="form-control text-right"
                  v-model="model.interest_outstand_undue"
                  :precision="2"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Next Installment	</label>
                </b-input-group-prepend>
                <my-number
                  class="form-control text-right"
                  v-model="model.next_installment_no"
                  :precision="0"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Next Installment Date	</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.next_installment_date" disabled></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Next Installment Due No	</label>
                </b-input-group-prepend>
                <my-number
                  class="form-control text-right"
                  v-model="model.next_installment_due_no"
                  :precision="0"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Next Due Date	</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.next_installment_due_date" disabled></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <hr />

      <hr />
      <b-row>
        <b-col lg="12">
          <b-input-group>
            <b-input-group-prepend>
              <label>Request Date</label>
            </b-input-group-prepend>
            <b-input type="date" v-model="model.requestdate" :state="!$v.model.requestdate.$error" disabled />
          </b-input-group>

          <b-row>
              <b-col md="5">
                  <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:140px;">Request By</label>
                  </b-input-group-prepend>
                  <b-form-input v-model="model.requestby" disabled></b-form-input>
                </b-input-group>
              </b-col>
          </b-row >
          
          <!-- <b-input-group>
            <b-input-group-prepend>
              <label>Request No.</label>
            </b-input-group-prepend>
            <b-form-input v-model="model.requestno" disabled></b-form-input>
          </b-input-group> -->

          <!-- <b-row>
              <b-col md="5">
                  <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:140px;">Release to</label>
                  </b-input-group-prepend>
                  <b-form-select
                    v-model="model.tiperelease"
                    :options="optReleaseTo"
                    :state="!$v.model.tiperelease.$error"
                  ></b-form-select>
                </b-input-group>
              </b-col>
          </b-row > -->

          <b-row>
              <b-col md="5">
                  <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:140px;">Release to</label>
                  </b-input-group-prepend>
                  <b-form-input v-model="model.releaseto" :state="!$v.model.releaseto.$error" disabled></b-form-input>
                </b-input-group>
              </b-col>
          </b-row >
          
          <!-- <b-row v-if="ifPaket">
              <b-col md="5">
                  <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:140px;">Nama Paket Pengirim</label>
                  </b-input-group-prepend>
                  <b-form-input v-model="model.paketpengirim"></b-form-input>
                </b-input-group>
              </b-col>
          </b-row >
          <b-row v-if="ifPaket">
              <b-col md="5">
                  <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:140px;">No. Resi</label>
                  </b-input-group-prepend>
                  <b-form-input v-model="model.noresi"></b-form-input>
                </b-input-group>
              </b-col>
          </b-row > -->

          <!-- <b-row v-if="!ifPaket">
              <b-col md="5">
                  <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:140px;">Nama Pengirim</label>
                  </b-input-group-prepend>
                  <b-form-input v-model="model.namapengirim"></b-form-input>
                </b-input-group>
              </b-col>
          </b-row > -->
          
          <b-input-group>
            <b-input-group-prepend>
              <label>Keterangan</label>
            </b-input-group-prepend>
            <b-form-textarea
              v-model="model.uraian"
              placeholder=""
              rows="5"
              max-rows="10"
              disabled
            ></b-form-textarea>
          </b-input-group>
        </b-col>
      </b-row>

      <hr />
      <b-table
        sticky-header 
        class="mb-0"
        ref="table"
        outlined
        responsive
        striped
        hover
        small
        style="font-size:smaller;max-height:500px !important;"
        :items="tblDataAsset.items"
        :fields="tblFieldsAsset"
        :current-page="tblDataAsset.page"
        :per-page="tblDataAsset.limit"
        :sort-by.sync="tblDataAsset.sortBy"
        :sort-desc.sync="tblDataAsset.sortDesc"
        :key="tblDataAsset.limit"
        :busy="isBusyTblAngsuran"
        :filter="filter"
        :filterIncludedFields="filterOn"
        @filtered="onFiltered"
        show-empty
      >

      <template v-slot:cell(ischecked)="data">
        <span v-if="data.item.ischecked === 1"><i class="fa fa-check-square fa-2x" style="color:#0075ff;" aria-hidden="true"></i></span>
        <span v-else><i class="fa fa-square-o fa-2x" style="color:#767676;" aria-hidden="true"></i></span>
      </template>
      
      <template v-slot:cell(index)="data">{{ data.index + 1 }}</template>

      <template v-slot:cell(no_jaminan)="data">
        <span :class="data.item.note!=''?'bg-warning text-dark p-2':''">
          {{data.item.no_jaminan}}
        </span>  
      </template>

        <template v-slot:cell(nilaijaminan)="data">{{
          data.item.nilaijaminan | numFormat('0,0.00')
        }}</template>
        <template v-slot:cell(alamat)="data">
          {{ data.item.alamat || "-" }}
          <br />
          Kelurahan : {{ data.item.kelurahan }} - Kecamatan :{{
            data.item.kecamatan
          }}
          <br />
          Kota : {{ data.item.kota }} - Provinsi :{{ data.item.provinsi }}
          <br />
          Kode Pos : {{ data.item.kodepos }}
        </template>
        <template v-slot:cell(detail)="data">
          <span v-if="data.item.tipejaminan == 'Kendaraan'">
            <b-row>
              <b-col md="6">- No. BPKB : {{ data.item.bpkb }}</b-col>
              <b-col md="6">- No. STNK : {{ data.item.stnk }}</b-col>
            </b-row>
            <b-row>
              <b-col md="6">- Status STNK : {{ data.item.statusstnk }}</b-col>
              <b-col md="6"
                >- Tanggal STNK :
                {{ data.item.tanggalstnk | moment("DD/MM/YY") }}</b-col
              >
            </b-row>
          </span>
          <span v-else>
            <b-row>
              <b-col md="6">
                - Luas Tanah : {{ data.item.luastanah }} m
                <sup>2</sup>
              </b-col>
              <b-col md="6">
                - Luas Bangunan : {{ data.item.luasbangunan }} m
                <sup>2</sup>
              </b-col>
            </b-row>
            - Status Sertifikat : {{ data.item.sertifikatstatus }}
            <span v-if="data.item.sertifikatstatus === 'lainnya'"
              >- {{ data.item.otherstatussertifikat }}</span
            >
            <b-row>
              <b-col md="6"
                >- No Sertifikat : {{ data.item.sertifikatno }}</b-col
              >
              <b-col md="6"
                >- Sertifikat Atas Nama : {{ data.item.pemilikjaminan }}</b-col
              >
            </b-row>
            <b-row>
              <b-col md="6">- Status PBB : {{ data.item.statuspbb }}</b-col>
              <b-col md="6">- Tanggal PBB: {{ data.item.tanggalpbb }}</b-col>
            </b-row>
            <b-row>
              <b-col md="6"
                >- Status Asuransi : {{ data.item.statusasuransi }}</b-col
              >
              <b-col md="6">- No. IMB : {{ data.item.noimb }}</b-col>
            </b-row>
          </span>
        </template>
        <template v-slot:cell(tgl_kontrak)="data">{{
          data.item.tgl_kontrak | moment("DD/MM/YY")
        }}</template>

        <template v-slot:table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
        <template v-slot:cell(empty)="data">
          <h4>{{ data.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="data">
          <h4>{{ data.emptyFilteredText }}</h4>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div align="left">
            Showing {{(tblDataAsset.page - 1) * tblDataAsset.limit + 1}}
            to
            <span
              v-if="((tblDataAsset.page * tblDataAsset.limit)>tblDataAsset.total)"
            >{{tblDataAsset.total}}</span>
            <span v-else>{{tblDataAsset.page * tblDataAsset.limit}}</span>
            of {{tblDataAsset.total}} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-form-group label style="margin-top:0 !important;">
            <b-input-group>
              <b-input-group-prepend class="mr-2">
                <label>Limit per page</label>
              </b-input-group-prepend>
              <div class="d-flex">
                <b-form-select
                  :options="[10, 15, 20, 25,50,75,100]"
                  :plain="true"
                  v-model="tblDataAsset.limit"
                  size="sm"
                  style="width:80px"
                />
              </div>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-pagination
            align="right"
            :total-rows="tblDataAsset.total"
            :per-page="tblDataAsset.limit"
            v-model="tblDataAsset.page"
            @click="getAssetData()"
          ></b-pagination>
        </b-col>
      </b-row>

      <div slot="footer">
        <div class="card-footer-actions text-center">
          <button
            class="btn btn-primary mr-1"
            v-b-tooltip.hover
            title
            @click="close()"
          >
            <i class="fa fa-close"></i> {{ $t("close") }}
          </button>
        </div>
      </div>

    </b-card>
    <b-modal
      v-model="lkuPinjamanShow"
      size="lg"
      :hide-footer="true"
      title="Daftar Pinjaman"
      :centered="true"
    >
      <lku-pinjaman @click="onSelectLkuPinjaman" :modelpinjaman="model.model_pinjaman"></lku-pinjaman>
    </b-modal>
    <b-modal v-model="showReport" size="lg" title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>   
  </div>
</template>

<style lang="scss" scoped>
  .table-red-text{
    color:red;
  }
</style>

<script>
import toastr from "mini-toastr";
import moment from "moment";
import Loading from 'vue-loading-overlay';

import myNumber from "../../components/my-number";
import lkuPinjaman from "./lkuPinjaman";
import pinjaman from "../../apis/pinjamankredit";
import asset from "../../apis/agunankredit";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  components: { Loading, myNumber, lkuPinjaman },
  mixins: [validationMixin],
  validations: {
    model: {
      pinjamankey: { required },
      requestdate: { required },
      // tiperelease: { required },
      releaseto: { required },
      selected: { required }
    },
  },
  data() {
    return {
      showReport:false,
      reportUrl:null,
      isLoading:false,
      tabIndex:0,
      model: { requestkey:"",pinjamankey: "",requestdate:"",releaseto: "",paketpengirim:"",noresi:"",selected: [],printall:1,
      next_installment_no:0,
      next_installment_date:'',
      next_installment_due_no:0,
      next_installment_due_date:'',
      principal_outstand_undue:0,
      interest_outstand_undue:0
      },
      lkuPinjamanShow: false,
      tblDataAsset: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "jaminankey",
        sortDesc: false,
        pemilikjaminan: null,
        lokasijaminan: null,
        nilai1: 0,
        nilai2: 0,
        no_kontrak: null,
        tipejaminan: "",
        statusasuransi: "",
        jaminankeys: [],
        sourceproject: this.$store.state.user.compcode||"",
      },
      isdetail: false,
      isBusyTblAngsuran: false,
      filter: "",
      filterOn: ["statuspay"],

      optReleaseTo: [
        { value: "", text: "-- SELECT ONE --" },
        { value: "self", text: "Diambil Sendiri oleh Debitur" },
        { value: "package", text: "Kirim via Paket" },
      ],

    };
  },
  props: ["modelpinjaman"],
  computed: {
    ifPaket() {
      return this.model.tiperelease == "package" ? true : false;
    },
    tblFieldsAsset() {
      const fields = [
        { key: "ischecked", label: "Checked" },
        { key: "index", label: "No." },
        {
          key: "no_jaminan",
          label: "No Jaminan",
          thClass: "text-center",
          thStyle: "width:500px",
          sortable: true,
        },
        {
          key: "namajaminan",
          label: "Nama Jaminan",
          thClass: "text-center",
          thStyle: "width:500px",
          sortable: true,
        },
        {
          key: "tipejaminan",
          label: "Tipe Jaminan",
          thClass: "text-center",
          thStyle: "width:500px",
          sortable: true,
        },
        {
          key: "nilaijaminan",
          label: "Nilai Jaminan",
          thClass: "text-center",
          tdClass: "text-right",
          thStyle: "width:500px",
          sortable: true,
        },
        {
          key: "pemilikjaminan",
          label: "Pemilik Jaminan",
          thClass: "text-center",
          tdClass: "text-right",
          thStyle: "width:500px",
          sortable: true,
        },
        {
          key: "alamat",
          label: "Alamat",
          thClass: "text-center",
          thStyle: "width:1500px",
          sortable: true,
        },
        {
          key: "detail",
          label: "Detail",
          thClass: "text-center",
          thStyle: "width:2000px",
          sortable: true,
        },
        {
          key: "note",
          label: "Note",
          thClass: "text-center",
          tdClass: "text-right",
          thStyle: "width:200px",
          sortable: true,
        },
      ];
      return fields;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
  },

  beforeUpdate: function () {},
  created: async function () {

    if (this.$route.params.requestkey) {
      this.model.requestkey = this.$route.params.requestkey;
      this.model.pinjamankey = this.$route.params.pinjamankey;
      this.isdetail = true;
      try {
        this.isLoading = true;
        const requestkey = this.model.requestkey;
        const data = await pinjaman.detailrequestedit(requestkey);
        const dtheader = data[0][0];
        for (const key in dtheader) {
          if (dtheader.hasOwnProperty(key)) {
            this.model[key] = dtheader[key];
          }
        }
        this.model.requestdate = this.model.requestdate
          ? moment(this.model.requestdate).format("YYYY-MM-DD")
          : "";
        this.model.tgl_kontrak = moment(this.model.tgl_kontrak).format(
          "YYYY-MM-DD"
        );
        this.model.startdate_frmt = moment(this.model.startdate).format('DD-MM-YYYY');
        this.model.duedate_frmt = moment(this.model.duedate).format('DD-MM-YYYY');
        this.model.next_installment_date= this.model.next_installment_date ? moment(this.model.next_installment_date).format('DD-MM-YYYY') : this.model.next_installment_date;
        this.model.next_installment_due_date= this.model.next_installment_due_date ? moment(this.model.next_installment_due_date).format('DD-MM-YYYY') : this.model.next_installment_due_date;

        const dtasset = data[1];
        this.tblDataAsset.items=dtasset;
        this.tblDataAsset.total = dtasset.length;
        
        for (const key in dtasset) {
          if (dtasset.hasOwnProperty(key)) {
            this.model.selected.push({
            jaminankey: dtasset[key].jaminankey,
            ischecked: dtasset[key].ischecked === 1 ? true : false
          });
          }
        }

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }

    } else {
      if (this.$route.params.pinjamankey) {
        this.model.pinjamankey = this.$route.params.pinjamankey;
        this.isdetail = true;
        try {
          this.isLoading = true;
          const pinjamankey = this.model.pinjamankey;
          
          const data = await pinjaman.detailrequest(pinjamankey);
          
          const dtpinjaman = data[0][0][0];
          for (const key in dtpinjaman) {
            if (dtpinjaman.hasOwnProperty(key)) {
              this.model[key] = dtpinjaman[key];
            }
          }
          this.model.tgl_kontrak = moment(this.model.tgl_kontrak).format("YYYY-MM-DD");
          this.model.startdate_frmt = moment(this.model.startdate).format('DD-MM-YYYY');
          this.model.duedate_frmt = moment(this.model.duedate).format('DD-MM-YYYY');
          this.model.next_installment_date= this.model.next_installment_date ? moment(this.model.next_installment_date).format('DD-MM-YYYY') : this.model.next_installment_date;
          this.model.next_installment_due_date= this.model.next_installment_due_date ? moment(this.model.next_installment_due_date).format('DD-MM-YYYY') : this.model.next_installment_due_date;
          
          const dtasset = data[0][1];
          this.tblDataAsset.items=dtasset;
          this.tblDataAsset.total = dtasset.length;

          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          console.log("error : ", error);
          toastr.error(JSON.stringify(error), "ERROR MESSAGE");
        }
        
      }
    }
  },
  watch:{},
  methods: {
    rowClass(item, type) {
      const today = moment().format('YYYY-MM-DD');
        if ((item && item.outstand_bunga ||0)>0.009 || (item && item.outstand_pokok||0) > 0.009) {
          if(moment(today).diff(moment(item.tgl_jttempo),'days')>-1){
            return 'text-danger';
          }else{
            return '';
          }
            
        }else{
          return '';
        }
        
      },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblData.total = filteredItems.length;
      this.tblData.page = 1;
    },
    onSelectLkuPinjaman(_selected) {
      this.model.pinjamankey = _selected.pinjamankey;

       this.tblDataPayment= {
            page: 1,
            limit: 50,
            total: 0,
            tgl1: '',
            tgl2: '',
            sortBy: "tglpaym",
            sortDesc: true,
            pinjamankey:'',
            items:[]
          },
          this.tabIndex=0;

      this.getData();
      this.lkuPinjamanShow = false;
    },

    ischeckedjaminan(val){
      const findjaminan = this.model.selected.find(x => ((x.jaminankey === val[0]) && (x.ischecked === true) ));
      if(findjaminan){
        return 'checked'
      }else{
        return '';
      }
    },

    checkedjaminan(item,record) {
      const jaminankey = item.target.attributes["data-jaminankey"].value;
      if (item.target.checked === true) {
        const findCheck = this.model.selected.find(x => ((x.jaminankey === jaminankey)));
        if (!(findCheck)){
          this.model.selected.push({
            jaminankey,
            // no_jaminan,
            // isLunas,
            // note,
            ischecked: item.target.checked
          });
        }else{
          this.model.selected.splice(findCheck, 1);
          this.model.selected.push({
            jaminankey,
            // no_jaminan,
            // isLunas,
            // note,
            ischecked: item.target.checked
          });
        }
      } else {
        const findIdx = this.model.selected.findIndex(x => ((x.jaminankey === jaminankey)));
        this.model.selected.splice(findIdx, 1);
      }
      //console.log("### this.model.selected: ", this.model.selected);
    },

    integer_to_roman(num) {
      if (typeof num !== 'number') 
      return false; 

      var digits = String(+num).split(""),
      key = ["","C","CC","CCC","CD","D","DC","DCC","DCCC","CM",
      "","X","XX","XXX","XL","L","LX","LXX","LXXX","XC",
      "","I","II","III","IV","V","VI","VII","VIII","IX"],
      roman_num = "",
      i = 3;
      while (i--)
      roman_num = (key[+digits.pop() + (i * 10)] || "") + roman_num;
      return Array(+digits.join("") + 1).join("M") + roman_num;
    },

    async save() {
      if(this.invalidModel){
        if (this.$v.model.$model.requestdate && this.$v.model.$model.releaseto && this.$v.model.$model.selected && this.$v.model.$model.selected.length === 0) {
          toastr.error("Please checked jaminan correctly.", "ERROR MESSAGE");
        }else{
          toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
        }
      }else {
          //console.log("#this.model: ", this.model);
          await pinjaman.saveRequest(this.model);
          toastr.success("Request RRD berhasil disimpan");
          router.push({ name: "loan.pelepasandokumen" });
      }
    },

    close() {
      router.push({ name: "loan.pelepasandokumen" });
    },
    async getData() {
    },
    async getAssetData(){
    },
  },
};
</script>